import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Erro capturado:', error, errorInfo);
  }

  render() {
    if (this.state.hasError && this.state.error) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#e8e8ed] p-6 font-sans text-black">
          <div className="ade-neu-card max-w-lg w-full p-8">
            <h1 className="mb-2 text-xl font-bold text-red-700">Ocorreu um erro</h1>
            <p className="mb-4 text-neutral-700">A aplicação encontrou um problema. Tente recarregar a página (F5).</p>
            <details className="mb-4 text-sm text-neutral-600">
              <summary className="cursor-pointer font-medium text-black">Detalhes técnicos</summary>
              <pre className="ade-neu-input mt-2 overflow-auto rounded p-3 text-xs text-black">
                {this.state.error.message}
              </pre>
            </details>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="ade-btn-gold relative z-10 w-full px-6 py-3"
            >
              Recarregar página
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
